import { render, staticRenderFns } from "./EventManage.vue?vue&type=template&id=463b0453"
import script from "./EventManage.vue?vue&type=script&lang=js"
export * from "./EventManage.vue?vue&type=script&lang=js"
import style0 from "./EventManage.vue?vue&type=style&index=0&id=463b0453&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports